import React from 'react';
import { Helmet } from 'react-helmet-async';
import ImportServices from '../components/ImportServices/ImportServices';
import ExportServices from '../components/ExportServices/ExportServices';
import ContactForm from '../components/ContactForm/ContactForm';
import styles from './Services.module.css';

export default function Services() {
  return (
    <>
      <Helmet>
        <title>Услуги ВЭД — Импорт, Экспорт, Таможенное оформление | Советник</title>
        <meta name="description" content="Полный спектр услуг по сопровождению ВЭД: таможенное оформление, логистика, сертификация, юридическое сопровождение импорта и экспорта. Получите бесплатную консультацию." />
        <link rel="canonical" href="https://konsultant-sovetnik.ru/services" />
        <meta property="og:title" content="Услуги ВЭД — Советник" />
        <meta property="og:description" content="Таможенное оформление, логистика, сертификация, юридическое сопровождение импорта и экспорта." />
        <meta property="og:url" content="https://konsultant-sovetnik.ru/services" />
        <meta property="og:image" content="https://konsultant-sovetnik.ru/logo512.png" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          "serviceType": "Сопровождение ВЭД",
          "provider": {
            "@type": "Organization",
            "name": "ООО Советник",
            "url": "https://konsultant-sovetnik.ru/"
          },
          "areaServed": ["Россия", "Европа", "Турция", "Китай", "Индия", "Вьетнам"],
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Услуги ВЭД",
            "itemListElement": [
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Таможенное оформление и сертификация" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Организация международной доставки" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Юридическое сопровождение сделок" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Финансовое сопровождение и валютный контроль" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Экспортные операции (агентская и трейдинговая модель)" } }
            ]
          }
        })}</script>
      </Helmet>
      <section className={styles.hero}>
        <div className={styles.container}>
          <span className={styles.badge}>Услуги</span>
          <h1 className={styles.title}>Наши услуги</h1>
          <p className={styles.subtitle}>
            Полный спектр услуг по сопровождению внешнеэкономической деятельности
          </p>
        </div>
      </section>
      <ImportServices />
      <ExportServices />
      <ContactForm type="calculation" />
    </>
  );
}
